import ListMixin from './listMixin';
import { userItemsPerListMixin } from '@/utils/vuex';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewISAssetMgmtList',
  mixins: [ListMixin, userItemsPerListMixin],
  data: function () {
    return {
      assetEditDialog: false,
      assetObject: null,
      indoor: false,
      outdoor: false,
      tableOptions: {
        ...defaultTableOptions
      },
      listPersistencePath: 'IsAssetMgmt.list'
    };
  },
  computed: {
    operationalStatus() {
      return {
        0: this.$i18n_t('NiotaClassic.Devices.form.unset'),
        1: this.$i18n_t('NiotaClassic.Devices.form.inTransit'),
        2: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$i18n_t('NiotaClassic.Devices.form.inOperation'),
        4: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      };
    },
    searchCategories() {
      return [{
        value: 'title',
        text: this.$i18n_t('Common.help.titel')
      }, {
        value: 'id',
        text: `Asset ${this.$i18n_t('Common.id')}`
      }, {
        value: 'floorDtwin.name',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.types.floor')
      }, {
        value: 'floorDtwin.number',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.map.floorLabel')
      }, {
        value: 'tag',
        text: this.$i18n_t('IS.AssetMgmt.list.category')
      }, {
        value: 'zone',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.types.zone')
      }];
    },
    localizedTableOptions() {
      return {
        headers: [{
          text: this.$i18n_t('Common.id'),
          value: 'id',
          align: 'right',
          sortable: true
        }, {
          text: this.$i18n_t('Common.help.titel'),
          value: 'title',
          sortable: true
        }, {
          text: this.$i18n_t('IS.AssetMgmt.list.category'),
          value: 'category',
          sortable: false
        }, {
          text: this.$i18n_t('DigitalTwin.DigitalTwin.types.floor'),
          sortable: true,
          value: 'floorDtwin.title'
        },
        // {
        //   text: this.$i18n_t('Common.tenant'),
        //   sortable: true,
        //   value: 'tenant.name',
        // },
        {
          text: this.$i18n_t('IS.AssetMgmt.list.lastSeen'),
          value: 'lastSeen',
          sortable: true
        }, {
          text: this.$i18n_t('NiotaClassic.Devices.details.operationalStatus'),
          value: 'operationalStatus',
          sortable: true
        }, {
          text: this.$i18n_t('IS.AssetMgmt.list.device'),
          value: 'device',
          sortable: false
        }, {}],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50]
        }
      };
    },
    headerBG() {
      return './img/consumer.png';
    }
  },
  created() {
    this.fetchType = 'trackable';
    this.tableOptions.page = defaultTableOptions.page;
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  mounted() {
    this.indoor = this.fetchOptions.indexOf('indoor') >= 0;
    this.outdoor = this.fetchOptions.indexOf('outdoor') >= 0;
  },
  methods: {
    toggleIndoor() {
      if (this.fetchOptions.indexOf('indoor') >= 0) {
        this.fetchOptions = this.fetchOptions.filter(o => o !== 'indoor' && o !== 'outdoor');
      } else {
        this.fetchOptions = this.fetchOptions.filter(o => o !== 'outdoor');
        this.fetchOptions.push('indoor');
      }
      this.fetchList(true);
      this.indoor = !this.indoor;
    },
    toggleOutdoor() {
      if (this.fetchOptions.indexOf('outdoor') >= 0) {
        this.fetchOptions = this.fetchOptions.filter(o => o !== 'outdoor' && o !== 'indoor');
      } else {
        this.fetchOptions = this.fetchOptions.filter(o => o !== 'indoor');
        this.fetchOptions.push('outdoor');
      }
      this.fetchList(true);
      this.outdoor = !this.outdoor;
    },
    handleAssetEdit(item) {
      this.assetObject = item;
      this.assetEditDialog = true;
    },
    handleRowClick(item) {
      this.$router.push(`/is-assetmgmt/assets/${item.id}`);
    },
    detailTableHeaderColClass(header, props) {
      let classes = [`text-${header.align || 'start'}`];
      if (header.sortable && ['title', 'id', 'floorDtwin.title'].indexOf(header.value) < 0) {
        classes.push('sortable');
      }
      const values = [header.value];
      if (props.options.sortBy && props.options.sortBy.length && values.indexOf(props.options.sortBy[0]) >= 0) {
        classes.push('active');
        if (props.options.sortDesc && props.options.sortDesc.length && props.options.sortDesc[0]) {
          classes.push('desc');
        } else {
          classes.push('asc');
        }
      }
      return classes.join(' ');
    },
    detailTableHeaderClasses(props) {
      const sortBy = props.options.sortBy && props.options.sortBy.length ? props.options.sortBy[0] : 'none';
      const sortDesc = props.options.sortDesc && props.options.sortDesc.length && props.options.sortDesc[0];
      return {
        text: {
          title: `header-item-sortable ${sortBy === 'title' ? 'header-active' : 'header-nonactive'}`,
          id: `header-item-sortable ${sortBy === 'id' ? 'header-active' : 'header-nonactive'}`,
          floorDtwinTitle: `header-item-sortable ${sortBy === 'floorDtwin.title' ? 'header-active' : 'header-nonactive'}`
        },
        icon: {
          title: sortBy === 'title' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive',
          id: sortBy === 'id' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive',
          floorDtwinTitle: sortBy === 'floorDtwin.title' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive'
        }
      };
    },
    closeEvent(e) {
      if (e) {
        this.fetchList();
      }
      this.assetEditDialog = false;
    }
  }
};